export default __webpack_public_path__ + "static/media/wave_big.cd3b2ce6.svg";